import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AbstractMatTableComponent } from '@app/shared/base/abstract-mat-table/abstract-mat-table.component';

@Component({
  selector: 'app-site-list-table',
  templateUrl: './site-list-table.component.html',
  styleUrls: ['./site-list-table.component.scss'],
})
export class SiteListTableComponent
  extends AbstractMatTableComponent
  implements OnInit
{
  @Output() openSiteDetail = new EventEmitter<{
    customerId: string;
    siteId: string;
    pageIndex: number;
  }>();

  displayedColumns: string[] = [
    'accountName',
    'debris',
    'accountServiceEquipment',
    'serviceDetails',
    'serviceType',
    'serviceDays',
    'action',
  ];

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    // Custom filterPredicate
    // eslint-disable-next-line func-names
    this.dataSource.filterPredicate = function (data, filter: string): boolean {
      const dataStr = Object.keys(data)
        .filter(key =>
          [
            'accountName',
            'isRecurringService',
            'debris',
            'accountServiceEquipment',
            'serviceDetails',
          ].includes(key)
        )
        .reduce((currentTerm: string, key: string) => {
          return currentTerm + (data as { [key: string]: any })[key] + '◬';
        }, '')
        .toLowerCase();

      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();

      return dataStr.indexOf(transformedFilter) !== -1;
    };
  }

  siteSelected(customerId: string, siteId: string) {
    // pass siteId and table pageNumber to parent component
    const { pageIndex } = this.dataSource.paginator;

    this.openSiteDetail.emit({ customerId, siteId, pageIndex });
  }
}
